import React, { useState, useEffect, useCallback } from "react";
import "./CandidateResumeSection.css";

import mammoth from "mammoth";

import { db } from "../utils/firebase";

import {
  doc,
  getDoc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

import { getAuth } from "firebase/auth";

import { saveAs } from "file-saver";

import {
  Document,
  Packer,
  Paragraph,
  TextRun,
} from "docx";



function CandidateResumeSection() {
  const [resumeText, setResumeText] = useState("");
  const [loading, setLoading] = useState(true);

  const auth = getAuth();

  const loadMasterResume = useCallback(async () => {
    try {
      const user = auth.currentUser;

      if (!user) {
        setLoading(false);
        return;
      }

      const userRef = doc(
        db,
        "users",
        user.uid
      );

      const snap = await getDoc(userRef);

      if (snap.exists()) {
        const data = snap.data();

        if (data.masterResume?.resumeText) {
          setResumeText(
            data.masterResume.resumeText
          );
        }
      }
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  },[auth.currentUser]);

  useEffect(() => {
    loadMasterResume();
  }, [loadMasterResume]);

  const saveMasterResume = async () => {
    try {
      const user = auth.currentUser;

      if (!user) return;

      await updateDoc(
        doc(db, "users", user.uid),
        {
          masterResume: {
            resumeText,
            updatedAt: serverTimestamp(),
          },
        }
      );

      alert("Master Resume Saved");
    } catch (err) {
      console.error(err);
      alert("Unable to save resume");
    }
  };

  const handleDocxUpload = async (file) => {
    try {
      const arrayBuffer =
        await file.arrayBuffer();

      const result =
        await mammoth.extractRawText({
          arrayBuffer,
        });

      setResumeText(result.value);
    } catch (err) {
      console.error(err);
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (
      file.name
        .toLowerCase()
        .endsWith(".docx")
    ) {
      await handleDocxUpload(file);
    }
  };

  const downloadDocx = async () => {
    const paragraphs =
      resumeText
        .split("\n")
        .map(
          (line) =>
            new Paragraph({
              children: [
                new TextRun({
                  text: line,
                  size: 22,
                }),
              ],
            })
        );

    const docFile =
      new Document({
        sections: [
          {
            children: paragraphs,
          },
        ],
      });

    const blob =
      await Packer.toBlob(
        docFile
      );

    saveAs(
      blob,
      "Resume.docx"
    );
  };

  if (loading) {
    return (
      <div>
        Loading Resume...
      </div>
    );
  }

  return (
    <div className="candidateResumeSection">

      <h2>
        Resume
      </h2>

      <div className="resumeActions">

        <label className="uploadButton">
          Upload DOCX

          <input
            type="file"
            accept=".docx"
            onChange={
              handleFileUpload
            }
            hidden
          />
        </label>

        <button
          onClick={
            loadMasterResume
          }
        >
          Load Master Resume
        </button>

        <button
          onClick={
            saveMasterResume
          }
        >
          Save Master Resume
        </button>

        <button
          onClick={downloadDocx}
        >
          Download DOCX
        </button>

      </div>

      <div className="resumeEditor">

        <h3>
          Resume Text
        </h3>

        <textarea
          className="resumeTextArea"
          value={resumeText}
          onChange={(e) =>
            setResumeText(
              e.target.value
            )
          }
          placeholder="Paste your resume here..."
        />

      </div>
    </div>
  );
}

export default CandidateResumeSection;